/**
 * API service for tasks module settings
 */
import { apiGet, apiPut } from '../../../shared/api/axiosInstance';

const TENANT_SETTINGS_URL = '/api/v1/tasks/settings/tenant';
const USER_SETTINGS_URL = '/api/v1/tasks/settings/user';

// ========== Types ==========

export interface WorkManagementTenantSettings {
  id?: string;
  tenant_id?: string;
  default_task_statuses: string[];
  require_due_date: boolean;
  require_assignee: boolean;
  allow_subitems: boolean;
  max_subitem_depth: number;
  settings?: Record<string, unknown>;
  updated_by?: string;
}

export interface WorkManagementTenantSettingsUpdate {
  default_task_statuses?: string[];
  require_due_date?: boolean;
  require_assignee?: boolean;
  allow_subitems?: boolean;
  max_subitem_depth?: number;
}

export interface WorkManagementUserSettings {
  id?: string;
  tenant_id?: string;
  user_id?: string;
  default_workspace_id?: string | null;
  default_board_id?: string | null;
  default_view: string;
  show_completed_tasks: boolean;
  compact_mode: boolean;
  settings?: Record<string, unknown>;
}

export interface WorkManagementUserSettingsUpdate {
  default_workspace_id?: string | null;
  default_board_id?: string | null;
  default_view?: string;
  show_completed_tasks?: boolean;
  compact_mode?: boolean;
}

// ========== API ==========

export const workManagementSettingsApi = {
  // Tenant settings (admin)
  getTenantSettings: async (): Promise<WorkManagementTenantSettings> => {
    return apiGet<WorkManagementTenantSettings>(TENANT_SETTINGS_URL);
  },

  updateTenantSettings: async (data: WorkManagementTenantSettingsUpdate): Promise<WorkManagementTenantSettings> => {
    return apiPut<WorkManagementTenantSettings>(TENANT_SETTINGS_URL, data);
  },

  // User settings
  getUserSettings: async (): Promise<WorkManagementUserSettings> => {
    return apiGet<WorkManagementUserSettings>(USER_SETTINGS_URL);
  },

  updateUserSettings: async (data: WorkManagementUserSettingsUpdate): Promise<WorkManagementUserSettings> => {
    return apiPut<WorkManagementUserSettings>(USER_SETTINGS_URL, data);
  },
};
